import React from "react";
import { AppBar, Box, Toolbar, Avatar, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import ProfileMenu from "./ProfileMenu/ProfileMenu";
import useStyles from "./styles";
import DandelionIcon from "../../images/DandelionIconWhite.png";
import Filters from "../Filters/Filters";

const Navbar = ({
  name,
  profile,
  img,
  artistLimit,
  setArtistLimit,
  timeRange,
  setTimeRange,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <AppBar className={classes.appBar} position="static">
        <Toolbar className={classes.toolbar}>
          <img
            src={DandelionIcon}
            className={classes.dandelionIcon}
            alt="Dandelion Icon"
          />
          <div className={classes.titleContainer}>
            <Typography
              component={Link}
              to="/"
              className={classes.title}
              variant="h4"
            >
              Dandelion
            </Typography>
          </div>
          <Filters
            artistLimit={artistLimit}
            setArtistLimit={setArtistLimit}
            timeRange={timeRange}
            setTimeRange={setTimeRange}
          />
          <Avatar className={classes.avatar} alt="spotify-img" src={img}>
            {name?.charAt(0)}
          </Avatar>
          <ProfileMenu name={name} profile={profile} />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
